module.exports = __webpack_public_path__ + "assets/Joomla.f5066db7.svg";